import { motion } from 'motion/react'
import React from 'react'
import styled from 'styled-components'

import { useApplicationContext } from '../../../contexts'
import type { FileItemProps } from '../types'
import { canOpenWechatDocument } from '../wechatPreview'

const PREVIEW_SERVICE = 'https://view.officeapps.live.com/op/view.aspx'

const Container = styled(motion.div)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
    // padding: '100px 144px'
})

const NativeDocumentPlaceholder = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    padding: 24,
    color: 'var(--color-gray-600)',
    textAlign: 'center',
    wordBreak: 'break-word'
})

export const OfficeFile = ({
    file,
    transform,
    dragOffset,
    disableWechatDocumentPreview
}: Pick<FileItemProps, 'file' | 'transform' | 'dragOffset' | 'disableWechatDocumentPreview'>) => {
    const { rotate = 0, scale = 100 } = transform ?? {}
    const { x = 0, y = 0 } = dragOffset ?? {}
    const { openWechatDocument } = useApplicationContext()
    const shouldOpenWithWechat = !disableWechatDocumentPreview && canOpenWechatDocument(file, openWechatDocument)

    return (
        <Container
            animate={{
                x,
                y,
                scale: scale / 100,
                rotate
            }}
        >
            {shouldOpenWithWechat ? (
                <NativeDocumentPlaceholder>{file.name}</NativeDocumentPlaceholder>
            ) : (
                <iframe
                    width="100%"
                    height="100%"
                    referrerPolicy="no-referrer"
                    src={`${PREVIEW_SERVICE}?src=${file.url}`}
                    title={file.name}
                />
            )}
        </Container>
    )
}
